export interface SafeAreaInsets {
  top: number
  right: number
  bottom: number
  left: number
}

export function defaultSetSafeAreaInsets(payload: SafeAreaInsets): void {
  Object.entries(payload).forEach(([key, value]) => {
    document.documentElement.style.setProperty(
      `--safe-area-${key}`,
      `${Math.round(value as number)}px`,
    )
  })
}
